import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { storeToRefs } from "pinia";
import { usePiniaState } from "@/store/userPinia";

import { getHeadList } from "@/api/im";
import { Toast } from "vant";
import ApiNetWork from "@/network/apiNet/apiNet";
import axios from "axios";
import EventBus from "@/uitls/EventBus";
import { msg_set_headurl } from "@/network/socket/SocketReq";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  name: 'Setting',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const piniaStore = usePiniaState();
const { user, isYk } = storeToRefs(piniaStore);
const appname = process.env.VUE_APP_TITLE as string;
const { toLogin } = piniaStore;
const downloadshow = ref(false);

onMounted(() => {
  toLogin();
  getAvarar()
});

onUnmounted(() => {
  EventBus.off("changeAvatarSuccecc")
})

EventBus.on("changeAvatarSuccecc", () => {
  Toast.success(t('me.szcg'))
  // updateSuccessImg
  user.value.avatar = updateSuccessImg.value;
  console.log(user.value.avatar);
  // router.back()
})
const avatar = ref([])
const getAvarar = async () => {
  const res: any = await getHeadList()
  if (res && res.ret == 0) {
    let templist = []
    for (let i = 0; i < res.data.length; i++) {
      let obj = {
        url: res.data[i],
        check: false
      }
      templist.push(obj)
    }
    avatar.value = templist
  } else {
    Toast.fail(t('me.hqsb'))
  }

}

const nameimg = () => {
  downloadshow.value = true;
};
const beforeRead = (file) => {
  const type = file.type
  if (type == 'image/jpeg' || type == 'image/png') {
    return true;
  }
  Toast(t('me.qscjpg'));
  return false;
};

const afterRead = (file) => {
  file.status = 'uploading';
  file.message = t('me.scz');
  uploaderImg(file)
}
const updateSuccessImg = ref('')
const uploaderImg = (file) => {
  //转菊花
  const toast = Toast.loading({
    duration: 0,
    forbidClick: true,
    message: t('me.tpscz'),
  });

  let second = 15;
  const timer = setInterval(() => {
    second--;
    if (second) {
      toast.message = t('me.tpscz');
    } else {
      clearInterval(timer);
      Toast.clear();
      Toast.fail(t('me.imgsubimterr'))
    }
  }, 1000);
  //end
  let img = file.file;

  let formData = new FormData();
  formData.append("file", img)
  const url = ApiNetWork.uploadGetAddress();

  //上传到php接口
  axios.post(`${url}app/appFileUpload`, formData).then((response) => {

    if (response.status == 200) {
      console.log("======>", response);
      clearInterval(timer);
      Toast.clear();
      //上传到pb
      msg_set_headurl(response.data)
      updateSuccessImg.value = response.data
    }
  });
}
const onOversize = (file) => {
  console.log(file);
  Toast(t('me.wjbncg'));
};
const checkUrl = (url: string, index: number) => {
  for (let i = 0; i <  avatar.value.length; i++) {
    avatar.value[i].check = false;
    
  }
  avatar.value[index].check = true;
}

//上传默认头像
const morlAvatar = () => {
  downloadshow.value = false
  let url = "";
  for (let i = 0; i <  avatar.value.length; i++) {
   if (avatar.value[i].check) {
    url = avatar.value[i].url
    break;
   }
  }
  if (url == "") {
    Toast.fail(t('me.qxztx'))
  }
  msg_set_headurl(url);
  updateSuccessImg.value = url;
}



const __returned__ = { t, router, route, piniaStore, user, isYk, appname, toLogin, downloadshow, avatar, getAvarar, nameimg, beforeRead, afterRead, updateSuccessImg, uploaderImg, onOversize, checkUrl, morlAvatar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})